import {FileAudioIcon} from './svg/file-audio-icon';
import {FileExcelIcon} from './svg/file-excel-icon';
import {FileIcon} from './svg/file-icon';
import {FileImageIcon} from './svg/file-image-icon';
import {FilePdfIcon} from './svg/file-pdf-icon';
import {FilePowerpointIcon} from './svg/file-powerpoint-icon';
import {FileTextIcon} from './svg/file-text-icon';
import {FileVideoIcon} from './svg/file-video-icon';
import {FileWordIcon} from './svg/file-word-icon';
import {FileZipIcon} from './svg/file-zip-icon';

export function getFileIcon(filetype: string): React.ComponentType<any> {
    switch (filetype) {
        case 'archive':
            return FileZipIcon;
        case 'audio':
            return FileAudioIcon;
        case 'spreadsheet':
            return FileExcelIcon;
        case 'image':
            return FileImageIcon;
        case 'pdf':
            return FilePdfIcon;
        case 'powerpoint':
            return FilePowerpointIcon;
        case 'text':
            return FileTextIcon;
        case 'keynote':
        case 'video':
            return FileVideoIcon;
        case 'doc':
            return FileWordIcon;
        case 'unknown':
        default:
            return FileIcon;
    }
}
